import React, { useState, useEffect, useRef } from 'react'
import { ChromePicker }  from 'react-color'
import { Form } from '../../../../interface'

interface ColorInputProps extends Form<string>{
  style?: {},
}

const ColorInput: React.FC<ColorInputProps> = ({
  style = {},
  onChange = (newValue: string) => null,
  value
}) => {

  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const popover: React.CSSProperties = {
    position: 'absolute',
    zIndex: 2,
  }
  const cover: React.CSSProperties = {
    position: 'fixed',
    top: '0px',
    right: '0px',
    bottom: '0px',
    left: '0px',
  }

  useEffect(() => {
    function handleBodyClick(e: Event) {
      setDisplayColorPicker(false)
    }

    function handlePicker(e: Event) {
      console.log('x')
      e.preventDefault()
      e.stopPropagation()
    }

    document.body.addEventListener('click', handleBodyClick)

    // TODO DOM way
    const picker = document.querySelector('.chrome-picker')
    if (picker) {
      picker.addEventListener('click', handlePicker)
    }

    return () => {
      removeEventListener('click', handleBodyClick)
      removeEventListener('click', handlePicker)
    }
  }, [displayColorPicker])

  return (
    <>
      {displayColorPicker ? 
        <div style={popover}>
          <ChromePicker
            onChange={color => onChange(color.hex)}
            color={value}
            styles={{
              default: {
                picker: {
                  position: 'relative',
                  top: '-100px',
                  left: '45px'
                }
              }
            }}
          />
        </div> : 
        null 
      }
      <button
        onClick={() => {
          setDisplayColorPicker(!displayColorPicker)
        }}
        style={{
          width: '40px',
          height: '40px',
          border: '1px solid #d9d9d9',
          ...style,
          backgroundColor: value
        }}
      >
      </button>
    </>
  )
}

export default ColorInput;
